import React, { useEffect, useState } from "react";
import "./referAFriend.css"; // Import the CSS file

import ReferImage5 from "../../assests/new/refer5.png";
import ReferImage7 from "../../assests/new/refer7.png";
import ReferImage8 from "../../assests/new/refer8.jpg";
import mobileRefer from "../../assests/new/mobileRefer.jpg";

import { useSelector } from "react-redux";
import { endPoints } from "../../constant/Environment";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
  InstapaperShareButton,
  InstapaperIcon,
} from "react-share";
import insta from "../../assests/new/insta.png";
import twitter from "../../assests/new/X-logo.png";
import { getAllBetData, getAllData } from "../../Utility/API";
import { ErrorToast } from "../../components/Toast/message";
import { Helmet } from "react-helmet";

const ReferFriend = () => {
  const state = useSelector((state) => state.auth);
  const userData = state?.user;
  const userId = userData?.idUser;
  const shareUrl = "https://yourwebsite.com";
  const title = "Refer a Friend and Get a Bonus!";

  const devUrl = "https://accountapi-dev.bettdraft.com:5000/";
  const stageUrl = "https://accountapi.bettdraft.com:5000/";
  const prodUrl = "https://accountapiprod.bettdraft.com:5000/";

  const [referralLink, setReferralLink] = useState(
    `https://dfs.bettdraft.com/?ref=${userId}&campaign=referFriend`
  );
  const [copied, setCopied] = useState(false);
  const [list, setList] = useState([]);

  useEffect(() => {
    let selectedEnv = checkEnv(endPoints.apiBaseUrl);
    setReferralLink(`${selectedEnv}?ref=${userId}&campaign=referFriend`);
  }, []);
  const checkEnv = (env) => {
    let naviagteUrl = "";
    switch (env) {
      case devUrl:
        naviagteUrl = "https://dev-dfs.bettdraft.com/";
        break;
      case stageUrl:
        naviagteUrl = "https://stage-dfs.bettdraft.com/";
        break;
      case prodUrl:
        naviagteUrl = "https://dfs.bettdraft.com/";
        break;
      default:
        naviagteUrl = "https://stage-dfs.bettdraft.com/";
    }
    return naviagteUrl;
  };

  const ReferalTable = async () => {
    const url = `${endPoints.apiBaseUrl}${endPoints.api.REFERAL_TABLE}/${userId}`;
    try {
      const response = await getAllBetData(url);
      if (response?.status == "success") {
        setList(response?.data?.userList);
      } else {
        ErrorToast(response?.message);
      }
    } catch (error) {
      console.log(error);
      ErrorToast(
        "Issue connecting to server (error code 15). Please contact support for further assistance."
      );
    }
  };

  useEffect(() => {
    if(state?.isAuthenticated){
    ReferalTable();
    }
  }, []);

  const transactions = [
    { name: "Bob Brown", status: "2", amount: 0.0 }, // No steps completed yet
  ];

  const renderStatus = (status) => {
    const steps = ["Signup", "ID Verification", "Bet"];
    const validStatus = [1, 2, 3].includes(Number(status)) ? Number(status) : 1;
    return (
      <div className="status-stepper">
        {steps.map((step, index) => (
          <div key={index} className="step">
            <div
              className={`circle ${
                validStatus >= index + 1 ? "completed" : ""
              }`}
            >
              {validStatus >= index + 1 && "✔"}
            </div>
            <span className="step-label">{step}</span>
          </div>
        ))}
      </div>
    );
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(referralLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 5000); // Reset after 5 seconds
  };

  return (
    <div>
      <Helmet>
        <title>Refer a Friend | BettDraft Fantasy Sports</title>
        <meta name="description" content="Refer your friends to BettDraft and earn rewards on daily fantasy sports contests." />
      </Helmet>
      <div className="refer-friend">
        <img
          alt="bettdraft"
          src={ReferImage8}
          className="w-100 d-md-block d-none"
        />
        <img
          alt="bettdraft"
          src={mobileRefer}
          className="w-100 d-md-none d-block"
        />
        <div className="refer-text">
          <p>Get $50 of bonus for each friend you refer.</p>
        </div>

        <div
          className="referal-copy-text-desktop"
          style={{ marginTop: "20px", textAlign: "center" }}
        >
          <p
            style={{
              fontSize: "22px",
              wordBreak: "break-word",
              margin: "10px 0",
            }}
          >
            {referralLink}
          </p>
          <button
            onClick={handleCopyLink}
            style={{
              padding: "10px 20px",
              fontSize: "16px",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            {copied ? "Copied!" : "Copy Referral Link"}
          </button>
        </div>

        <div className="refer-button">
          <div style={{ display: "flex", gap: "10px" }}>
            <FacebookShareButton url={referralLink} quote={title}>
              <FacebookIcon size={36} round />
            </FacebookShareButton>

            <TwitterShareButton url={referralLink} title={title}>
              <img
                src={twitter}
                alt="twitter_icon"
                style={{ height: 64, width: 64 }}
              />
            </TwitterShareButton>

            <WhatsappShareButton url={referralLink} title={title}>
              <WhatsappIcon size={36} round />
            </WhatsappShareButton>
          </div>
        </div>
      </div>

      <div
        className="referal-copy-text-mobile"
        style={{ marginTop: "20px", textAlign: "center" }}
      >
        <p
          style={{
            fontSize: "20px",
            wordBreak: "break-word",
            margin: "10px 0",
          }}
        >
          {referralLink}
        </p>
        <button
          onClick={handleCopyLink}
          style={{
            padding: "10px 20px",
            fontSize: "16px",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          {copied ? "Copied!" : "Copy Referral Link"}
        </button>
      </div>

      <div className="main-referral-box">
        <h4 style={{ fontSize: "22px", marginBottom: "10px" }}>
          Referral Transaction History
        </h4>
        <div className="referral-transaction-table table-responsive">
          <table className="table table-bordered">
            <thead className="thead-light">
              <tr>
                <th>Sr. No.</th>
                <th>Name</th>
                <th
                  className="status-column"
                >
                  Status
                </th>
                <th>Balance</th>
              </tr>
            </thead>
            <tbody>
              {list?.length > 0 ? (
                list.map((transaction, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{transaction?.name}</td>
                    <td className="status-column">
                      {renderStatus(transaction?.status)}
                    </td>
                    <td>
                      {transaction?.status == 3
                        ? `${transaction?.amount}`
                        : "Pending"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">No referral transactions</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ReferFriend;
